{
  "slug": "iq-score-ranges-explained",
  "title": "IQ score ranges explained",
  "description": "Explore common IQ score bands, approximate percentiles, confidence intervals, and the limits of labels.",
  "summary": "IQ score bands are convenient summaries, but boundaries and labels vary by test. Scores should be interpreted as estimates and in context.",
  "sections": [
    {
      "heading": "A practical guide to common ranges",
      "paragraphs": [
        "For a scale with a mean of 100 and standard deviation of 15, these bands provide general orientation. They are not diagnostic categories."
      ],
      "bullets": [
        "130 and above: approximately the top 2%",
        "120–129: approximately the 91st–97th percentiles",
        "110–119: approximately the 75th–90th percentiles",
        "90–109: broad middle range",
        "80–89: approximately the 9th–24th percentiles",
        "70–79: approximately the 2nd–8th percentiles",
        "Below 70: approximately the lowest 2%"
      ]
    },
    {
      "heading": "Why labels differ",
      "paragraphs": [
        "Publishers and institutions use different terms and cutoffs. A result at a boundary is not meaningfully different from one a point away, and confidence intervals often cross more than one band.",
        "High or low results should not be interpreted from the total alone. A professional considers adaptive functioning, development, education, and language when relevant."
      ]
    },
    {
      "heading": "Read the profile, not only the number",
      "paragraphs": [
        "Two people with the same overall score may have different strengths. One might excel in verbal reasoning while another performs best on visual patterns. A composite can hide these differences.",
        "Use an online score as a snapshot under particular conditions, not a permanent label."
      ]
    }
  ],
  "faqs": [
    {
      "question": "What is considered a high IQ?",
      "answer": "On many scales, 120 or above is well above average and 130 or above is around the top 2%, but terminology varies."
    },
    {
      "question": "Are IQ range boundaries exact?",
      "answer": "No. Measurement error and differing classification systems make boundaries approximate."
    }
  ],
  "related": [
    "what-is-the-average-iq",
    "what-does-an-iq-of-120-mean",
    "what-does-an-iq-of-140-mean"
  ]
}
